import { useNavigation } from "@remix-run/react";

export default function useIsWorking() {
  const { state } = useNavigation();
  return state === "loading" || state === "submitting";
}
